<th></th>
<th>
  <a (click)="sortBy('name')">
    <span>{{ "homepage.cards.knowledges.placeholder_name" | translate }}</span>
    @if (sortValue === 'name' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'name' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('author')">
    <span>{{
      "homepage.cards.knowledges.placeholder_author" | translate
    }}</span>
    @if ( sortValue === 'author' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'author' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('contributors')">
    <span>{{
      "homepage.cards.knowledges.placeholder_contributors" | translate
    }}</span>
    @if ( sortValue === 'contributors' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'contributors' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('knowledges')">
    <span>{{
      "homepage.cards.knowledges.placeholder_entry_number" | translate
    }}</span>
    @if ( sortValue === 'knowledges' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'knowledges' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
